import _axios from 'axios';

import { Transporter } from '../interfaces/transporters.interface';

const axios = _axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_SERVER_URL,
});

export class TransporterService {
  async getTransporters() {
    return axios.get("/transporters");
  }
  async updateTransporter(id: string, transporter: Transporter) {
    return axios.put(`/transporters/${id}`, transporter);
  }
  async addTransporter(transporter: Transporter) {
    // Remove _id when creating a new transporter - let MongoDB auto-generate
    const { _id, ...transporterWithoutId } = transporter;
    return axios.post("/transporters", transporterWithoutId);
  }
  async deleteTransporter(id: string) {
    return axios.delete(`/transporters/${id}`);
  }
}
